import React from "react";
import { ArrowDownIcon, PhoneIcon } from "lucide-react";
const steps = [{
  number: "1",
  title: "See what’s open",
  description: "Current Big Yellow vacancies are listed on the careers page, and every open role is also advertised on SEEK."
}, {
  number: "2",
  title: "Apply or register interest",
  description: "Apply to an advertised role, or register your interest if the right one isn’t listed yet. A name, email and area of work is enough to start."
}, {
  number: "3",
  title: "Talk to the team",
  description: "If there’s a suitable opportunity, the team can contact you using the details you provide. Role details are confirmed before anything is agreed."
}];
export function HowItWorks() {
  return <section id="how-it-works" aria-labelledby="how-heading" className="bg-[#FDF3D6] text-black" data-id="element-260" data-mp="gloq0unfdwqw">
      <div className="mx-auto w-full max-w-[1600px] px-6 py-[3.75rem] md:py-[5.25rem] lg:px-12 xl:px-20" data-id="element-261" data-mp="uhaft41hgkkd">
        <div className="grid gap-8 md:grid-cols-12 md:items-end" data-id="element-262" data-mp="qfylwmbktd6d">
          <div className="md:col-span-7" data-id="element-263" data-mp="24ds88gee2ua8">
            <p className="mb-5 text-[0.8125rem] font-semibold uppercase tracking-[0.14em] text-[#005A73]" data-id="element-264" data-mp="28dt13628j80t">Your next step</p>
            <h2 id="how-heading" className="text-4xl font-bold leading-[0.98] tracking-[-0.04em] sm:text-5xl lg:text-7xl" data-id="element-265" data-mp="2dcmdev5scsze">What happens when you reach out.</h2>
          </div>
        </div>

        <ol className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-266" data-mp="2nblcpn4nvc9q">
          {steps.map(step => <li key={step.number} className="flex flex-col border-t-4 border-black pt-6" data-id="element-267" data-mp="2rc57ik1ri3sp">
              <span className="font-display text-5xl font-bold leading-none" data-id="element-268" data-mp="2w3ncrkatiqjh">{step.number}</span>
              <h3 className="mt-6 text-2xl font-semibold" data-id="element-269" data-mp="3126wde1xvq8o">{step.title}</h3>
              <p className="mt-3 text-base leading-7 text-black/75" data-id="element-270" data-mp="314azhts0kl7w">{step.description}</p>
            </li>)}
        </ol>

        <div className="mt-14 flex flex-col gap-6 border-t border-black/20 pt-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-271" data-mp="3b04k80fvzl0r">
          <div data-id="element-272" data-mp="2lda8h2r71ce3">
            <p className="text-xl font-semibold" data-id="element-273" data-mp="2lcs41iudnrv3">Rather talk it through first?</p>
            <p className="mt-1 text-base text-black/70" data-id="element-274" data-mp="2geqjsul7tmi1">Welshpool office · Monday to Friday, 8:00am–5:00pm</p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row" data-id="element-275" data-mp="2v4eng2gvcx8x">
            <a href="tel:+61862634753" className="btn btn-ghost-dark btn-sm" data-id="element-276" data-mp="2qak635oqkud0">
              <PhoneIcon aria-hidden="true" size={17} data-id="element-277" data-mp="342guozr74m4n" /> (08) 6263 4753
            </a>
            <a href="#enquire" className="btn btn-dark btn-sm" data-id="element-278" data-mp="2z3x58pde8s7j">
              Register your interest <ArrowDownIcon aria-hidden="true" size={17} className="btn-icon-down" data-id="element-279" data-mp="2z69qbbeg7iot" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}